if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const spinner = this.querySelector('.loading__spinner');
        let accepted = false;
        let requestStarted = false;
        this.error = false;

        try {
          this.handleErrorMessage();
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          spinner?.classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const cartReady = this.cart && ['getSectionsToRender', 'setActiveElement', 'renderContents'].every(
            (method) => typeof this.cart[method] === 'function'
          );

          if (cartReady) {
            try {
              const sections = this.cart.getSectionsToRender().map((section) => section.id);
              this.cart.setActiveElement(document.activeElement);
              formData.set('sections', sections.join(','));
              formData.set('sections_url', window.location.pathname);
            } catch (error) {
              console.error(error);
              formData.delete('sections');
              formData.delete('sections_url');
              this.cart = null;
            }
          } else {
            this.cart = null;
          }
          config.body = formData;

          requestStarted = true;
          const result = await fetch(routes.cart_add_url, config);
          const response = await result.json();

          if (!result.ok || response.status) {
            const message = typeof response.description === 'string'
              ? response.description
              : typeof response.errors === 'string'
                ? response.errors
                : window.cartStrings.error;
            this.handleErrorMessage(message);
            try {
              Promise.resolve(publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || message,
                message: response.message,
              })).catch((error) => console.error(error));
            } catch (error) {
              console.error(error);
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            }
            return;
          }

          accepted = true;
          if (!this.cart) {
            window.location.assign(window.routes.cart_url);
            return;
          }

          try {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            })).catch((error) => console.error(error));
          } catch (error) {
            console.error(error);
          }

          const renderCart = () => {
            try {
              this.cart.renderContents(response);
            } catch (error) {
              console.error(error);
              window.location.assign(window.routes.cart_url);
            }
          };
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => setTimeout(renderCart), { once: true });
            quickAddModal.hide(true);
          } else {
            renderCart();
          }
        } catch (error) {
          console.error(error);
          if (accepted) {
            window.location.assign(window.routes.cart_url);
          } else {
            this.handleErrorMessage(requestStarted ? this.dataset.cartUnconfirmed : window.cartStrings.error);
          }
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
          if (typeof CartPerformance !== 'undefined') {
            try {
              CartPerformance.measureFromEvent('add:user-action', evt);
            } catch (error) {
              console.error(error);
            }
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
